// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Ellipsis as RawEllipsis } from "lucide-react";
export const Ellipsis = /* @__PURE__ */ createIcon(RawEllipsis, "Ellipsis", 2);
